<template>
  <div ref="kandidat">
    <m-card-list
      :title="title"
      id-key
      :filter="false"
      :items="items"
      refresh
      @refresh="load"
      footerLabel="Instruktur"
      :headers="headers"
      :page="page"
      @change:page="
        pg => {
          cp = pg;
          load();
        }
      "
      @add="add"
      footer
    >
      <template v-slot:items="{ item }">
        <tr v-if="$vuetify.breakpoint.smAndUp">
          <td>
            {{ pVal(item.instruktur, "name") }}
          </td>
          <td>{{ pVal(item.instruktur, "email") }}</td>
          <td>{{ pVal(item.instruktur, "nomor_hp") }}</td>
          <td>{{ pVal(item.materi, "keterangan") }}</td>
          <td>{{ pVal(item.sesi, "keterangan") }}</td>

          <td align="center">
            <v-icon @click="add(item)" color="blue darken-4">mdi-plus-circle</v-icon>
          </td>
        </tr>
        <tr v-else>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              Nama
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item.instruktur, "name") }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              Surel
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item.instruktur, "email") }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              Nomor HP
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item.instruktur, "nomor_hp") }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              Modul
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item.materi, "keterangan") }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              Sesi
            </div>
            <div class="v-data-table__mobile-row__cell">
              {{ pVal(item.sesi, "keterangan") }}
            </div>
          </td>
          <td class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header mr-2">
              Aksi
            </div>
            <div class="v-data-table__mobile-row__cell">
              <v-icon @click="add(item)" color="blue darken-4">mdi-plus-circle</v-icon>
            </div>
          </td>
        </tr>
        <v-divider />
      </template>
    </m-card-list>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    // tipe 0 = daftar kandidat, tipe 1 = = kandidat terpilih
    tipe: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      items: [],
      textSearch: null,
      selectedItems: [],
      page: null,
      cp: 1,
      current_page: 0,
      headers: [
        { text: "Nama Lengkap", align: "left", value: "nama" },
        { text: "Surel", align: "left", value: "tanggal_masuk" },
        { text: "Nomor HP", align: "left", value: "role" },
        {
          text: "Modul",
          align: "left",
          value: "is_face_verified"
        },
        { text: "Sesi", align: "left", value: "k_status" },
        { text: "Aksi", align: "center", sortable: false }
      ]
    };
  },
  mounted() {
    this.load();
  },
  computed: {},
  methods: {
    load() {
      return this.$store
        .dispatch("grup/getKandidat", {
          instansi_id: this.instansi_id,
          diklat_id: this.diklat_id,
          grup_id: this.$route.params.grup_id,
          params: {
            page: this.cp,
            limit: 10
          }
        })
        .then(res => {
          this.page = res;
          this.items = res.data;
        })
        .catch(e => e);
    },
    add(obj) {
      this.$confirm(
        `Apakah Anda yakin akan memilih Instruktur berikut ?<br>
        <div class="mt-2 title grow text-center">
          
        </div>`
      )
        .then(() =>
          this.$store.dispatch("grup/addInstruktur", {
            instansi_id: this.instansi_id,
            diklat_id: this.diklat_id,
            grup_id: this.$route.params.grup_id,
            obj: obj
          })
        )
        .then(res => {
          this.selectedItems = [];
          if (res.status == 201) {
            this.load();
            return this.$info("Pengguna terpilih berhasil dikeluarkan dari kelas");
          }
        })
        .then(() => this.$emit("load"))
        .catch(e => e);
    }
  },
  watch: {
    changeData() {
      this.load();
    }
  }
};
</script>
